<template>
<div id="tab1" class="t-color-bodyGrayB pdl-16 pdr-16 pdt-30 mgt-100 pdb-20">
        <!-- <div class="h-50"></div>
        <div class="h-32"></div> -->
        <img src="/images/helpdesk/notice_nodata.svg" alt="" class="d-block mgx-auto noDataImage">
        <div class="pdt-24 pdl-16 pdr-16 pdb-4 t-subtitle3 t-color-headlineBlack t-center font-m l-spacing48">{{$t('3090')}}
        </div>
    </div>
</template>

<script>
/**
 * 데이터 없음 컴포넌트(no data Components)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
export default {
  
};
</script>
<style scoped>
.noDataImage{
  width: 123px;
}
</style>